import { ReactNode, useEffect } from "react";
import { useNotificationRuntime } from "./notification-runtime-context";

interface IUseNotificationCandidate {
  id: string;
  priority: number;
  isActive: boolean;
  delayMs?: number;
  render: () => ReactNode;
}

export const useNotificationCandidate = ({ id, priority, isActive, delayMs, render }: IUseNotificationCandidate) => {
  const { removeCandidate, upsertCandidate } = useNotificationRuntime();

  useEffect(() => {
    upsertCandidate({
      id,
      priority,
      isActive,
      delayMs,
      render,
    });
  }, [delayMs, id, isActive, priority, render, upsertCandidate]);

  useEffect(() => {
    return () => {
      removeCandidate(id);
    };
  }, [id, removeCandidate]);
};
